import API from './API.ts'

export default {
  //
  // GET
  //
  getStaticData () {
    return API.httpClient.get('static-data')
  },
  getUsers () {
    return API.httpClient.get('users')
  },
  getRoles () {
    return API.httpClient.get('users/roles')
  },
  getPermissions () {
    return API.httpClient.get('users/roles/permissions')
  },
  getWorkstation ({ machineId, hostname }) {
    return API.httpClient.get('users/workstation', {
      params: {
        machine_id: machineId,
        hostname
      }
    })
  },
  generatePassword () {
    return API.httpClient.get('users/generate-password')
  },

  //
  // POST
  //
  createUser ({ name, username, email, password, roleId, color, phoneNumber, diallingCodeCountryId }) {
    return API.httpClient.post('users/create', {
      name,
      username,
      email,
      password,
      role_id: roleId,
      color,
      phone_number: phoneNumber,
      dialling_code_country_id: diallingCodeCountryId
    })
  },
  updateUser ({ userId, name, username, email, password, roleId, color, phoneNumber, diallingCodeCountryId }) {
    return API.httpClient.post('users/update', {
      user_id: userId,
      name,
      username,
      email,
      password: password || undefined,
      role_id: roleId,
      color,
      phone_number: phoneNumber,
      dialling_code_country_id: diallingCodeCountryId
    })
  },
  updateUserMainMenuConfig ({ userId, mainMenuConfig }) {
    return API.httpClient.post('users/update-main-menu-config', {
      user_id: userId,
      main_menu_config: mainMenuConfig
    })
  },
  updatePassword ({ userId, newPassword }) {
    return API.httpClient.post('users/update-password', {
      user_id: userId,
      new_password: newPassword
    })
  },
  deleteUser (userId) {
    return API.httpClient.post('users/delete', {
      user_id: userId
    })
  },
  createRole ({ readableName, permissions, hiddenMenuItems }) {
    return API.httpClient.post('users/roles/create', {
      readable_name: readableName,
      permissions,
      hidden_menu_items: hiddenMenuItems
    })
  },
  updateRole ({ roleId, readableName, permissions, hiddenMenuItems }) {
    return API.httpClient.post('users/roles/update', {
      role_id: roleId,
      readable_name: readableName,
      permissions,
      hidden_menu_items: hiddenMenuItems
    })
  },
  deleteRole (roleId) {
    return API.httpClient.post('users/roles/delete', {
      role_id: roleId
    })
  }
}
